module.exports = __webpack_public_path__ + "img/tmf-icon-M-rounded.01eaf046.webp";